import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';

// Primary tab of the WM Charge Profile form (Delphi uWMD0008). Holds the profile block and the User
// Defined Codes block; the codes are WMCODES lookups configured in Layout.js, so there is no
// client-side option loading to do here.
function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    // FormField calls onFormLoad() unconditionally in a finally block with no default and no guard
    // (FormField.js:256), so it is a required prop even when there is nothing to load. The lookups on
    // this form fetch their own data, hence the no-op.
    const handleFormLoad = useCallback(() => {
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='FABF4AA7-38E3-4334-9DC6-F721C449BCE5'
                layoutName='WMChargeProfilePrimaryForm'
                defaultFormSchema={PrimaryLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);
